function tabClick(e){9===e.keyCode&&(document.body.classList.add("js-using-tab"),window.removeEventListener("keydown",tabClick))}window.addEventListener("keydown",tabClick),window.theme??={},window.theme.wrapRteTables=(e=document)=>{e.querySelectorAll(".rte table").forEach((e=>{if(e.closest(".js-theme-utility-rte-table-wrap"))return;const t=document.createElement("div");var o,n;t.classList.add("js-theme-utility-rte-table-wrap"),t.setAttribute("style","overflow:auto;-webkit-overflow-scrolling:touch"),n=t,(o=e).parentNode.insertBefore(n,o),n.appendChild(o)}))},window.theme.wrapRteTables();const scrollEndSupported="undefined"==typeof window||"onscrollend"in window;scrollEndSupported||import("scrollyfills");
//# sourceMappingURL=global.js.map



// document.addEventListener("DOMContentLoaded", () => {
//     const headerLogo = document.querySelector(".header__logo");
//     const desktopIconNav = document.querySelector(".desktop__icon-nav");

//     if (headerLogo && desktopIconNav) {
//         const headerLogoWidth = headerLogo.offsetWidth;
//         const desktopIconNavWidth = desktopIconNav.offsetWidth;

//         document.body.style.setProperty("--header-logo-width", `${headerLogoWidth}px`);
//         document.body.style.setProperty("--desktop-icon-nav-width", `${desktopIconNavWidth}px`);

//         console.log("CSS Variables set:");
//         console.log("--header-logo-width:", `${headerLogoWidth}px`);
//         console.log("--desktop-icon-nav-width:", `${desktopIconNavWidth}px`);
//     } else {
//         console.error("Elements not found: Ensure .header__logo and .desktop__icon-nav exist.");
//     }
// });


const observer = new MutationObserver(() => {
    const headerLogo = document.querySelector(".header__logo");
    const desktopIconNav = document.querySelector(".desktop__icon-nav");

    if (headerLogo && desktopIconNav) {
        const headerLogoWidth = headerLogo.offsetWidth;
        const desktopIconNavWidth = desktopIconNav.offsetWidth;

        document.body.style.setProperty("--header-logo-width", `${headerLogoWidth}px`);
        document.body.style.setProperty("--desktop-icon-nav-width", `${desktopIconNavWidth}px`);
        observer.disconnect(); // Stop observing once elements are found
    }
});

observer.observe(document, { childList: true, subtree: true });

